// extracted by mini-css-extract-plugin
module.exports = {"bopDetailAddressClass":"DetailsPage_bopDetailAddressClass__26PWw","bopDetailsBuildingIcon":"DetailsPage_bopDetailsBuildingIcon__33aQ5"};